import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: 'input[appIsDecimal]'
})
export class IsDecimalDirective {
  @Input() decimals = 2;
  @Input() nums = 2;
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    let regex = '^\\s*((\\d{1,' + this.nums + '}(\\.\\d{0,' + this.decimals + '})?)|((\\d{1,' + this.nums + '}(\\.\\d{1,' + this.decimals + '}))))\\s*$';
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(new RegExp(regex))) {
      event.preventDefault();
    }
  }
}
